module.exports = __webpack_public_path__ + "static/media/ios-mic.afbb719f.svg";